module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"info":"The discover area is not ready yet. If enough people shared public lists, you can search and discover them here."},"de":{"info":"Die Entdecken-Sektion ist noch nicht freigeschaltet. Wenn genug Mitglieder öffentliche Listen geteilt haben, kannst du diese hier suchen und entdecken."}}')
  delete Component.options._Ctor
}
